/**
 * Normalize API text prompt group shape (camelCase / snake_case)
 * For Media Devoted | Created By Ciro Autiero
 */

import type { TextPromptGroup } from '../types/campaign-texts.types';

type RawTextPromptGroup = TextPromptGroup & {
  orderIndex?: number;
  parentId?: string | null;
};

export function normalizeTextPromptGroup(raw: RawTextPromptGroup): TextPromptGroup {
  return {
    ...raw,
    order_index: raw.order_index ?? raw.orderIndex ?? 0,
    parent_id: raw.parent_id ?? raw.parentId ?? null,
    prompt: raw.prompt ?? '',
  };
}
